import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import style from '../index.module.scss'
import { selectTotalItems } from '../store/slice'

export const Header = () => {
  const total = useSelector(selectTotalItems)

  return (
    <>
      <div
        className={['dFlex justifyContentBetween', style.headerTitle].join(' ')}
      >
        <Element
          style={{
            fontSize: 24,
            fontWeight: 600,
            color: '#0553A5',
            textTransform: 'uppercase',
          }}
        >
          <Translate value="library.main.DOWNLOADED_FILES" />
        </Element>
        <div
          className={style.totalTitle}
          style={{
            backgroundColor: '#EFF3FA',
          }}
        >
          <Element
            elementName="p"
            style={{
              fontWeight: 600,
              lineHeight: '24px',
            }}
          >
            <Translate value="library.downloadedFiles.TOTAL_AVAILABLE_FILES" />
          </Element>
          <Element
            elementName="p"
            style={{
              fontSize: 16,
              fontWeight: 600,
              lineHeight: '24px',
            }}
          >
            {total}
          </Element>
        </div>
      </div>
    </>
  )
}
